import { theme } from 'antd';
import { ThemeConfigType } from './typing';

const colorBgContainer = '#333333'; // Dark background
const colorBgLayout = '#222222'; // Slightly darker background

const themeId = 'dark-tritanopia';

export const darkTritanopiaTheme: ThemeConfigType = {
  id: themeId,
  type: 'dark',
  name: `themes.${themeId}`,
  previewImage: 'https://github.githubassets.com/assets/dark_tritanopia_preview-f9b3d5f2509f.svg',
  previewImageDisc: 'https://github.githubassets.com/assets/dark_tritanopia_disc-606f4df188f0.svg',
  theme: {
    algorithm: [theme.darkAlgorithm],
    token: {
      blue: '#8B8BFF', // Adjusted blue for Tritanopia
      purple: '#B08BFF', // Adjusted purple for Tritanopia
      cyan: '#8BFFFF', // Adjusted cyan for Tritanopia
      green: '#8BFF8B', // Adjusted green for Tritanopia
      magenta: '#FF8BFF', // Adjusted magenta for Tritanopia
      pink: '#FF8BB2', // Adjusted pink for Tritanopia
      red: '#FF8B8B', // Adjusted red for Tritanopia
      orange: '#FFB08B', // Adjusted orange for Tritanopia
      yellow: '#FFFF8B', // Adjusted yellow for Tritanopia
      volcano: '#FF8B5E', // Adjusted volcano for Tritanopia
      geekblue: '#8B8BB2', // Adjusted geekblue for Tritanopia
      gold: '#FFD700', // Adjusted gold for Tritanopia
      lime: '#BFFF8B', // Adjusted lime for Tritanopia
      colorPrimary: '#8B8BFF', // Adjusted primary color for Tritanopia
      colorSuccess: '#8BFF8B', // Adjusted success color for Tritanopia
      colorWarning: '#FFD700', // Adjusted warning color for Tritanopia
      colorError: '#FF8B8B', // Adjusted error color for Tritanopia
      colorInfo: '#8B8BFF', // Adjusted info color for Tritanopia
      colorLink: '#8B8BFF', // Adjusted link color for Tritanopia
      colorTextBase: '#FFFFFF', // Base text color
      colorBgBase: '#222222', // Base background color
      lineWidth: 1,
      lineType: 'solid',
      borderRadius: 6,
      colorText: 'rgba(255, 255, 255, 0.85)', // Main text color
      colorTextSecondary: 'rgba(255, 255, 255, 0.65)', // Secondary text color
      colorTextTertiary: 'rgba(255, 255, 255, 0.45)', // Tertiary text color
      colorTextQuaternary: 'rgba(255, 255, 255, 0.25)', // Quaternary text color
      colorFill: 'rgba(255, 255, 255, 0.15)', // Fill color
      colorFillSecondary: 'rgba(255, 255, 255, 0.10)', // Secondary fill color
      colorFillTertiary: 'rgba(255, 255, 255, 0.08)', // Tertiary fill color
      colorFillQuaternary: 'rgba(255, 255, 255, 0.04)', // Quaternary fill color
      colorBgLayout: colorBgLayout,
      colorBgContainer: colorBgContainer,
      colorBgElevated: '#333333', // Elevated background color
      colorBgSpotlight: 'rgba(255, 255, 255, 0.85)', // Spotlight background color
      colorBgBlur: 'transparent', // Blur background
      colorBorder: '#444444', // Border color
      colorBorderSecondary: '#555555', // Secondary border color
      // colorPrimaryBg: '#3333FF', // Primary background color
      // colorPrimaryBgHover: '#4D4DFF', // Primary background hover color
      // colorPrimaryBorder: '#3333FF', // Primary border color
      // colorPrimaryBorderHover: '#4D4DFF', // Primary border hover color
      // colorPrimaryHover: '#4D4DFF', // Primary hover color
      // colorPrimaryActive: '#6666FF', // Primary active color
      // colorPrimaryTextHover: '#4D4DFF', // Primary text hover color
      // colorPrimaryText: '#8B8BFF', // Primary text color
      // colorPrimaryTextActive: '#6666FF', // Primary text active color
      colorSuccessBg: '#338833', // Success background color
      colorSuccessBgHover: '#44AA44', // Success background hover color
      colorSuccessBorder: '#338833', // Success border color
      colorSuccessBorderHover: '#44AA44', // Success border hover color
      colorSuccessHover: '#44AA44', // Success hover color
      colorSuccessActive: '#55CC55', // Success active color
      colorSuccessTextHover: '#44AA44', // Success text hover color
      colorSuccessText: '#8BFF8B', // Success text color
      colorSuccessTextActive: '#55CC55', // Success text active color
      colorErrorBg: '#883333', // Error background color
      colorErrorBgHover: '#AA4444', // Error background hover color
      colorErrorBgActive: '#CC5555', // Error background active color
      colorErrorBorder: '#883333', // Error border color
      colorErrorBorderHover: '#AA4444', // Error border hover color
      colorErrorHover: '#AA4444', // Error hover color
      colorErrorActive: '#CC5555', // Error active color
      colorErrorTextHover: '#AA4444', // Error text hover color
      colorErrorText: '#FF8B8B', // Error text color
      colorErrorTextActive: '#CC5555', // Error text active color
      colorWarningBg: '#888833', // Warning background color
      colorWarningBgHover: '#AAAA44', // Warning background hover color
      colorWarningBorder: '#888833', // Warning border color
      colorWarningBorderHover: '#AAAA44', // Warning border hover color
      colorWarningHover: '#AAAA44', // Warning hover color
      colorWarningActive: '#CCCC55', // Warning active color
      colorWarningTextHover: '#AAAA44', // Warning text hover color
      colorWarningText: '#FFD700', // Warning text color
      colorWarningTextActive: '#CCCC55', // Warning text active color
      colorInfoBg: '#333388', // Info background color
      colorInfoBgHover: '#4444AA', // Info background hover color
      colorInfoBorder: '#333388', // Info border color
      colorInfoBorderHover: '#4444AA', // Info border hover color
      colorInfoHover: '#4444AA', // Info hover color
      colorInfoActive: '#5555CC', // Info active color
      colorInfoTextHover: '#4444AA', // Info text hover color
      colorInfoText: '#8B8BFF', // Info text color
      colorInfoTextActive: '#5555CC', // Info text active color
      colorLinkHover: '#4D4DFF', // Link hover color
      colorLinkActive: '#6666FF', // Link active color
      colorBgMask: 'rgba(0, 0, 0, 0.65)', // Background mask color
      colorWhite: '#FFFFFF', // White color
      lineWidthBold: 2, // Bold line width
      colorFillContent: 'rgba(255, 255, 255, 0.10)', // Fill content color
      colorFillContentHover: 'rgba(255, 255, 255, 0.08)', // Fill content hover color
      colorFillAlter: 'rgba(255, 255, 255, 0.04)', // Fill alter color
      colorBgContainerDisabled: 'rgba(255, 255, 255, 0.25)', // Disabled background container color
      colorBorderBg: '#444444', // Border background color
      colorSplit: 'rgba(255, 255, 255, 0.06)', // Split color
      colorTextPlaceholder: 'rgba(255, 255, 255, 0.25)', // Text placeholder color
      colorTextDisabled: 'rgba(255, 255, 255, 0.25)', // Text disabled color
      colorTextHeading: 'rgba(255, 255, 255, 0.85)', // Text heading color
      colorTextLabel: 'rgba(255, 255, 255, 0.85)', // Text label color
      colorTextDescription: 'rgba(255, 255, 255, 0.65)', // Text description color
      colorTextLightSolid: '#FFFFFF', // Light solid text color
      colorHighlight: '#8B8BFF', // Highlight color
      colorBgTextHover: 'rgba(255, 255, 255, 0.08)', // Background text hover color
      colorBgTextActive: 'rgba(255, 255, 255, 0.15)', // Background text active color
      colorIcon: 'rgba(255, 255, 255, 0.85)', // Icon color
      colorIconHover: 'rgba(255, 255, 255, 1.0)', // Icon hover color
      colorErrorOutline: 'rgba(255, 139, 139, 0.8)', // Error outline color
      colorWarningOutline: 'rgba(255, 215, 0, 0.8)', // Warning outline color
      controlItemBgHover: 'rgba(255, 255, 255, 0.08)', // Control item background hover color
      controlItemBgActive: '#4D4DFF', // Control item background active color
      controlItemBgActiveHover: '#6666FF', // Control item background active hover color
      controlItemBgActiveDisabled: 'rgba(255, 255, 255, 0.15)', // Control item background active disabled color
      controlTmpOutline: 'rgba(0, 0, 0, 0.1)', // Control temporary outline color
      controlOutline: 'rgba(0, 0, 0, 0.2)', // Control outline color
      linkDecoration: 'none', // Link decoration
      linkHoverDecoration: 'none', // Link hover decoration
      linkFocusDecoration: 'none', // Link focus decoration
      boxShadow:
        '\n      0 6px 16px 0 rgba(0, 0, 0, 0.2),\n      0 3px 6px -4px rgba(0, 0, 0, 0.2),\n      0 9px 28px 8px rgba(0, 0, 0, 0.2)\n    ', // Box shadow
      boxShadowSecondary:
        '\n      0 6px 16px 0 rgba(0, 0, 0, 0.15),\n      0 3px 6px -4px rgba(0, 0, 0, 0.15),\n      0 9px 28px 8px rgba(0, 0, 0, 0.15)\n    ', // Secondary box shadow
      boxShadowTertiary:
        '\n      0 1px 2px 0 rgba(0, 0, 0, 0.1),\n      0 1px 6px -1px rgba(0, 0, 0, 0.1),\n      0 2px 4px 0 rgba(0, 0, 0, 0.1)\n    ', // Tertiary box shadow
    },
  },
  layout: {
    hashId: themeId,
    colorPrimary: '#8B8BFF', // Adjusted primary color for Tritanopia
    colorTextAppListIcon: 'rgba(255, 255, 255, 0.85)', // App list icon text color
    colorBgAppListIconHover: 'rgba(255, 255, 255, 0.1)', // App list icon background hover color
    colorTextAppListIconHover: 'rgba(255, 255, 255, 1.0)', // App list icon text hover color
    bgLayout: `linear-gradient(${colorBgContainer}, ${colorBgLayout} 28%)`, // Layout background gradient
    sider: {
      paddingInlineLayoutMenu: 8, // Inline padding for layout menu
      paddingBlockLayoutMenu: 0, // Block padding for layout menu
      colorBgCollapsedButton: '#333333', // Collapsed button background color
      colorTextCollapsedButtonHover: 'rgba(255, 255, 255, 1.0)', // Collapsed button text hover color
      colorTextCollapsedButton: 'rgba(255, 255, 255, 0.85)', // Collapsed button text color
      colorMenuBackground: 'transparent', // Menu background color
      colorMenuItemDivider: 'rgba(255, 255, 255, 0.1)', // Menu item divider color
      colorBgMenuItemHover: 'rgba(255, 255, 255, 0.1)', // Menu item background hover color
      colorBgMenuItemSelected: 'rgba(255, 255, 255, 0.15)', // Menu item background selected color
      colorTextMenuItemHover: 'rgba(255, 255, 255, 1.0)', // Menu item text hover color
      colorTextMenuSelected: 'rgba(255, 255, 255, 1.0)', // Menu item text selected color
      colorTextMenuActive: 'rgba(255, 255, 255, 0.85)', // Menu item text active color
      colorTextMenu: 'rgba(255, 255, 255, 0.85)', // Menu item text color
      colorTextMenuSecondary: 'rgba(255, 255, 255, 0.65)', // Menu item text secondary color
      colorTextMenuTitle: 'rgba(255, 255, 255, 1.0)', // Menu item text title color
      colorTextSubMenuSelected: 'rgba(255, 255, 255, 1.0)', // Sub menu item text selected color
      colorBgMenuItemActive: 'rgba(255, 255, 255, 0.15)', // Menu item background active color
      colorBgMenuItemCollapsedElevated: 'transparent', // Collapsed menu item elevated background color
    },
    header: {
      colorBgHeader: 'rgba(0, 0, 0, 0.85)', // Header background color
      colorBgScrollHeader: 'rgba(0, 0, 0, 0.9)', // Scroll header background color
      colorHeaderTitle: 'rgba(255, 255, 255, 0.85)', // Header title color
      colorBgMenuItemHover: 'rgba(255, 255, 255, 0.1)', // Menu item background hover color
      colorBgMenuItemSelected: 'transparent', // Menu item background selected color
      colorTextMenuSelected: 'rgba(255, 255, 255, 1.0)', // Menu item text selected color
      colorBgRightActionsItemHover: 'rgba(255, 255, 255, 0.1)', // Right actions item background hover color
      colorTextRightActionsItem: 'rgba(255, 255, 255, 0.85)', // Right actions item text color
      heightLayoutHeader: 56, // Header height
      colorTextMenu: 'rgba(255, 255, 255, 0.85)', // Menu item text color
      colorTextMenuSecondary: 'rgba(255, 255, 255, 0.65)', // Menu item text secondary color
      colorTextMenuActive: 'rgba(255, 255, 255, 1.0)', // Menu item text active color
      colorBgMenuElevated: 'rgba(0, 0, 0, 0.85)', // Elevated menu background color
    },
    pageContainer: {
      colorBgPageContainer: 'transparent', // Page container background color
      paddingInlinePageContainerContent: 40, // Inline padding for page container content
      paddingBlockPageContainerContent: 32, // Block padding for page container content
      colorBgPageContainerFixed: '#333333', // Fixed page container background color
    },
  },
};
